import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types"
import * as Yup from 'yup';
import { useNibbleForm } from 'components/Nibble/Hooks/UseNibbleForm';
import { Alert, Button, Card, CardBody, Col, Form, Offcanvas, OffcanvasBody, OffcanvasHeader, Row, Table } from 'reactstrap';

import { MEXICO_STATES } from 'helpers/states';
import { deleteTruck, getProducts, getTrucks, postTruck, putTruck } from 'helpers/backend_helper';
import ModalDelete from 'components/Nibble/Common/Modales/ModalDelete';
import { set } from 'lodash';

const cpRegExp = /^[0-9]{5}/;

const Trucks = ({ model, setModel }) => {
    const [curTruck, setCurTruck] = useState({})
    const [offCanvasIsOpen, setOffCanvasIsOpen] = useState(false)
    const [error, setError] = useState("")
    const [completed, setCompleted] = useState("")
    const [btnSaveLoad, setBtnSaveLoad] = useState(false)
    const [position, setPosition] = useState(null)
    const [selectedRegion, setSelectedRegion] = useState(model.invoice_address?.region_id)
    const [products, setProducts] = useState([])
    const [trucks, setTrucks] = useState([])
    const [modalDelete, setModalDelete] = useState(false)

    const addTruck = (indexTruck, edit = false) => {
        let truck = { ...(indexTruck != null ? trucks[indexTruck] : {}) }
        truck.edit = edit
        truck.indexTruck = indexTruck

        setCurTruck(truck)
        setOffCanvasIsOpen(true)
    }

    const delTruck = async () => {
        // Delete Farm
        console.log('truck a eliminar', curTruck);
        await deleteTruck(model.id, curTruck)
        fetchTrucks()
        setModalDelete(false)
    }

    const toggleRightCanvas = () => {
        setCompleted(null)
        setOffCanvasIsOpen(!offCanvasIsOpen)
    }

    const { validation, render } = useNibbleForm({
        formScheme: [
            { md: 12, name: 'name', label: 'Nombre', type: 'text' },
            { md: 12, name: 'regions', label: 'Zonas de cobertura', type: 'multi-select', selectItems: MEXICO_STATES, selectOptionValue: (option) => `${option.name}` },
            { md: 12, name: 'products', label: 'Productos', type: 'multi-select', selectItems: products }
        ],
        validationScheme: Yup.object().shape({
            name: Yup.string().required('Requerido'),
            regions: Yup.array().min(1, 'Seleccione al menos una zona de cobertura').required('Requerido'),
            products: Yup.array().min(1, 'Seleccione al menos un producto').required('Requerido'),
        }),
        defaultModelValues: {
            regions: [],
            products: [],
        },
        model: curTruck,
        onSubmit: async (values) => {
            console.log('values', values)
            setCurTruck({ ...values })
            setBtnSaveLoad(true)
            try {
                const obj = JSON.parse(localStorage.getItem("authUser"))
                console.log('user', obj.user);
                console.log('modelo', { id: model.id, ...values })

                let newModel = {}
                let payload = {
                    ...values
                }
                if (curTruck?.edit) {
                    const response = await putTruck(model.id, { id: curTruck.id, ...payload, region_id: selectedRegion })
                    newModel = { ...model }
                    fetchTrucks()
                } else {
                    const response = await postTruck(model.id, { ...payload, region_id: selectedRegion })
                    newModel = { ...model }
                    fetchTrucks()
                    toggleRightCanvas()
                }

                setModel(newModel)
                setError(null)
                setCompleted('Se completo la operación')
            } catch (error) {
                console.log(error)
                setError(error.toString())
                setCompleted(null)
            }
            setBtnSaveLoad(false)
        }
    });

    const fetchTrucks = () => {
        getTrucks(model.id).then((response) => {
            setTrucks(response.map(e => {
                e.products = e.products.map(p => ({ ...p, capacity: p.pivot.capacity }));
                return e;
            }) || [])
        })
    }

    useEffect(() => {
        getProducts().then(setProducts)
        fetchTrucks()
    }, [])

    return (
        <>
            <Card>
                <CardBody>
                    <table className="table table-responsive table-bordered table-sm">
                        <thead>
                            <tr className='bg-light'>
                                <th>Camión</th>
                                <th>Zonas de cobertura</th>
                                <th>Productos / Capacidad</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(trucks || []).map((truck, key) => (
                                <tr key={key}>
                                    <td>{truck.name}</td>
                                    <td>
                                        {truck.regions
                                            ? truck.regions.reduce((prev, cur) => {
                                                return (
                                                    prev +
                                                    ("label" in cur ? cur.label : cur.name) +
                                                    " - "
                                                )
                                            }, "")
                                            : ""}
                                    </td>
                                    <td>
                                        {(truck.products || []).map((item) => {
                                            return (
                                                <>
                                                    {item.name}: {item.pivot?.capacity} piezas <br />
                                                </>
                                            )
                                        })}
                                    </td>
                                    <td>
                                        <Button
                                            type="button"
                                            className="btn btn-warning btn-sm"
                                            onClick={() => addTruck(key, true)}
                                        >
                                            <i className="fas fa-edit"></i>
                                        </Button>{" "}
                                        <Button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => {
                                                console.log('truck', truck);
                                                setCurTruck(truck)
                                                setModalDelete(true)
                                            }}
                                        >
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>

                            ))}
                            {model.deliveries_address?.length == 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center">Sin Camiones</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={6} className="text-center">
                                    <Button type="button" className="btn btn-danger btn-sm" onClick={() => addTruck()}>
                                        <i className="fas fa-plus"></i> Agregar camión
                                    </Button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </CardBody>
            </Card>
            <Offcanvas
                isOpen={offCanvasIsOpen}
                direction="end"
                toggle={toggleRightCanvas}
            >
                <OffcanvasHeader toggle={toggleRightCanvas}>
                    {'edit' in curTruck && curTruck.edit ? 'Modificar camión' : 'Nuevo camión'}
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            console.log('submit');
                            e.preventDefault();
                            validation.handleSubmit(e)
                            return false;
                        }}
                    >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        {completed ? <Alert color="success">{completed}</Alert> : null}
                        <Row>
                            {
                                //JSON.stringify(position)
                            }
                            {render()}
                        </Row>
                        <Row className='mt-4'>
                            <Col md={12}>
                                <Table bordered size='sm' striped>
                                    <thead>
                                        <tr className='bg-light'>
                                            <th>Producto</th>
                                            <th>Capacidad (piezas)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(validation.values.products || []).map((item, key) => (
                                            <tr key={key}>
                                                <td>{'label' in item ? item.label : item.name}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={item.capacity || ''}
                                                        onChange={(e) => {
                                                            let newProducts = [...validation.values.products]
                                                            newProducts[key] = { ...newProducts[key], capacity: e.target.value }
                                                            validation.setFieldValue('products', newProducts)
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        <div className="text-center mt-3">
                            <button type="submit" className="btn btn-sm btn-danger w-md" disabled={btnSaveLoad}>
                                <i className="fas fa-save"></i> Guardar
                            </button>
                            <button type="button" className="btn btn-sm btn-danger w-md ms-2" disabled={btnSaveLoad} onClick={toggleRightCanvas}>
                                <i className="fas fa-reply"></i> Cerrar
                            </button>
                        </div>
                    </Form>
                </OffcanvasBody>
            </Offcanvas>
            <ModalDelete
                show={modalDelete}
                onCloseClick={() => {
                    setModalDelete(false)
                }
                }
                onDeleteClick={() => {
                    delTruck(curTruck)
                }}
            />
        </>
    );
};

Trucks.propTypes = {
    model: PropTypes.object.isRequired,
    setModel: PropTypes.func.isRequired,
};

export default Trucks;